import React, { useState } from "react"
import "./../../AllCompanysTable.css"

import { FaEdit, FaTrash } from "react-icons/fa"
import ModalDeleteCompany from "../../../../Modal/ModalDeleteCompany"
import ModalEditCompanyStatus from "../../../../Modal/ModalEditCompanyStatus"
import CustomTable from "components/Common/CustomTable"
import { parseDebtorTable } from "./helpers/parseDebtorTable"

const DebtorTable = ({
  dataArray,
  currentPage,
  setCurrentPage,
  setCompanySelected,
  setShowList,
  totalPages,
}) => {
  const [isModalDeleteOpen, setIsModalDeleteOpen] = useState(false)
  const [isModalEditStatusOpen, setIsModalEditStatusOpen] = useState(false)
  const [companyToEdit, setCompanyToEdit] = useState()

  const handleSelectCompanyToEditStatus = company => {
    setCompanyToEdit(company)
    setIsModalEditStatusOpen(true)
  }

  const handleSelectCompanyToDelete = company => {
    setCompanyToEdit(company)
    setIsModalDeleteOpen(true)
  }

  const handleSelectCompany = company => {
    setCompanySelected(company)
    setShowList(null)
  }

  return (
    <div className="company-table-container">
      {isModalDeleteOpen && (
        <ModalDeleteCompany
          companyId={companyToEdit.Id}
          urlTo={"devedoras"}
          setIsModalOpen={setIsModalDeleteOpen}
          setCurrentPage={setCurrentPage}
        />
      )}
      {isModalEditStatusOpen && (
        <ModalEditCompanyStatus
          urlTo={"xp"}
          setCurrentPage={setCurrentPage}
          setIsModalOpen={setIsModalEditStatusOpen}
          companySelected={companyToEdit}
        />
      )}
      <CustomTable
        data={parseDebtorTable({
          data: dataArray,
          onStatusClick: handleSelectCompanyToEditStatus,
          onEditClick: handleSelectCompany,
          onDeleteClick: handleSelectCompanyToDelete,
        })}
        pagination={{
          currentPage,
          onPageChange: setCurrentPage,
          totalPages,
        }}
        autoHeight
      />
    </div>
  )
}

export default DebtorTable
